<template>
  <div class="matches-layout">
    <m-scrollbar id="favorite-overview-scrollbar" @scroll-up="scrollY(arguments[0], true)" @scroll-down="scrollY(arguments[0], false)">
      <live-list @scroll-to-top="scrollTop = 0" />
    </m-scrollbar>
    <m-loader
      :top="isTopLoader"
      v-if="loading || (scrollLoading && (screenBottom < scrollTop + (clientHeight - 100) || screenTop > scrollTop + 100))" />
  </div>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import MLoader from '@/components/sports/matches/Loader'
import LiveList from '@/components/favorites/LiveList'
import { mapState } from 'vuex'

export default {
  components: { MScrollbar, MLoader, LiveList },
  data () {
    return {
      scrollTop: 0,
      clientHeight: 0
    }
  },
  computed: {
    ...mapState({
      loading: state => state.favorites.live.loader.loading,
      scrollLoading: state => state.favorites.live.loader.scrollLoading,
      isTopLoader: state => state.favorites.live.loader.top,
      screenTop: state => state.favorites.live.screen.top,
      screenBottom: state => state.favorites.live.screen.bottom
    })
  },
  mounted () {
    let view = document.querySelector('#favorite-overview-scrollbar')
    view.scrollTop = 0
    this.clientHeight = view.clientHeight
  },
  methods: {
    scrollY (event, up) {
      this.$store.commit('favorites/SET_LOADER_POSITION', {
        type: 'live',
        position: up ? 'top' : 'bottom'
      })
      let view = document.querySelector('#favorite-overview-scrollbar')
      this.scrollTop = view.scrollTop
      let doit = () => {
        this.scrollTop = view.scrollTop
        this.$store.dispatch('favorites/GET_OVERVIEW', {
          params: {
            top: this.scrollTop,
            height: view.clientHeight
          },
          type: 'live',
          scroll: true
        })
      }
      setTimeout(function () { doit() }, 100)
    }
  }
}
</script>

<style scoped>
.matches-layout { height: 100%; margin-top: -40px; padding-top: 50px; overflow: hidden; position: relative; }
</style>



// WEBPACK FOOTER //
// src/components/favorites/LiveView.vue